import { Theme, styled as muiStyled } from '@mui/system';
import { CreateMUIStyled } from '@mui/system/createStyled';

import { BasetenTheme } from '.';

const styled = muiStyled as unknown as CreateMUIStyled<BasetenTheme & Pick<Theme, 'spacing'>>;

export { styled };
